import { useEffect, useState } from "react";
import { styles } from "../../styles";
import { ErrorNote } from "../common";
import { listAudit, type AuditEntry } from "../../data/audit";

function stamp(at: Date | null): string {
  if (!at) return "";
  return at.toLocaleString("en-US", {
    month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
  });
}

export function ActivityCard() {
  const [entries, setEntries] = useState<AuditEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = async () => {
    setError(null);
    try {
      setEntries(await listAudit(100));
    } catch (err) {
      console.error("Failed to load activity log:", err);
      setError("We could not load the activity log. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { void refresh(); }, []);

  return (
    <div style={styles.card}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 12 }}>
        <h2 style={styles.cardTitle}>Activity log</h2>
        <button className="link" style={{ ...styles.linkBtn, margin: 0 }} onClick={() => { setLoading(true); void refresh(); }}>
          Refresh
        </button>
      </div>
      <p style={styles.sub}>A record of admin changes. Entries cannot be edited or removed.</p>
      {error && <ErrorNote>{error}</ErrorNote>}

      {loading ? (
        <p style={styles.sub}>Loading&hellip;</p>
      ) : entries.length === 0 ? (
        <p style={styles.sub}>No activity recorded yet.</p>
      ) : (
        <ul style={{ ...styles.blockList, gap: 0 }}>
          {entries.map((e) => (
            <li key={e.id} style={{ padding: "10px 0", borderBottom: "1px solid var(--line)" }}>
              <div style={{ fontSize: 14.5, color: "var(--ink)" }}>{e.summary}</div>
              <div style={{ fontSize: 12.5, color: "var(--muted)", marginTop: 2 }}>
                {e.actorEmail || "unknown"} &middot; {stamp(e.at)}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
